module.exports = "/_next/static/images/57ff47432de4a721a68e922ba07469a8-google-pay.png.webp";